import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=fbb2bc8a&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/util.css?vue&type=style&index=0&id=fbb2bc8a&scoped=true&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=fbb2bc8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb2bc8a",
  null
  
)

export default component.exports